import { PurchaseAgreementListApp } from "document/list/app";
import DocumentV1CopyApp from "documentV1/copy/App";
import DocumentV1DetailApp from "documentV1/detail/App";
import DocumentV1NewApp from "documentV1/new/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const purchaseAgreementRoute: RouteObject = {
  children: [{
    index: true,
    loader: () => viewModel,
    path: "purchaseagreement",
    Component: PurchaseAgreementListApp,
  }, {
    path: "purchaseagreement/new",
    loader: () => viewModel,
    Component: DocumentV1NewApp,
  }, {
    path: "purchaseagreement/detail/:documentId",
    loader: () => viewModel,
    Component: DocumentV1DetailApp,
  }, {
    path: "purchaseagreement/copy/:documentId",
    loader: () => viewModel,
    Component: DocumentV1CopyApp,
  }]
};